(function () {
  if (customElements.get('ce-copy-to-clipboard') !== undefined) {
    return;
  }

  class CopyToClipboard extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        button: '[data-copy-to-clipboard-button]',
        toaster: 'ce-toaster',
      };

      this.elements = null;

      this.text = this.getAttribute('text');

      this.handleClickButton = this.handleClickButton.bind(this);
    }

    parsedCallback() {
      this.elements = {
        button: this.querySelector(this.selectors.button),
        toaster: document.querySelector(this.selectors.toaster),
      };

      this.elements.button.addEventListener('click', this.handleClickButton);
    }

    disconnectedCallback() {
      this.elements.button.removeEventListener('click', this.handleClickButton);
    }

    async handleClickButton() {
      try {
        await navigator.clipboard.writeText(this.text);
        this.elements.toaster.makeToast('success', Themu.t.general.success_messages.copy_to_clipboard);
      } catch (error) {
        this.elements.toaster.makeToast('danger', Themu.t.general.error_messages.copy_to_clipboard);
      }
    }
  }

  customElements.define('ce-copy-to-clipboard', CopyToClipboard);
})();
